import React from "react";
import { useState } from "react";
import { BrowserRouter,Routes, Route } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import ExpenseCategory from "./pages/settings/ExpenseCategory";
import BusinessList from "./pages/business/BusinessList";
import ClientList from "./pages/clients/ClientList";
import ProjectList from "./pages/clients/ProjectList";
import CommitmentLetter from "./pages/contracts/commitmentletter/CommitmentLetter";
import AddDemandLetter from "./pages/contracts/demandletter/AddDemandLetter";
import DemandLetters from "./pages/contracts/demandletter/DemandLetters";
import AddEmployeeContract from "./pages/contracts/employeecontracts/AddEmployeeContract";
import AddLogisticsSupportQuotation from "./pages/contracts/LogisticsSupportQuotation/AddLogisticsSupportQuotation";
import SupportQuotation from "./pages/contracts/LogisticsSupportQuotation/SupportQuotation";
import EmployeeContracts from "./pages/contracts/employeecontracts/EmployeeContracts";
import Dashboard from "./pages/home/Dashboard";
import AddEmployee from "./pages/hr/AddEmployee";
import AddSalary from "./pages/hr/AddSalary";
import EditEmployee from "./pages/hr/EditEmployee";
import EmployeeDetails from "./pages/hr/EmployeeDetails";
import EmployeesList from "./pages/hr/EmployeesList";
import Salary from "./pages/hr/Salary";
import SalaryDetails from "./pages/hr/SalaryDetails";
import AddInvoice from "./pages/invoicing/AddInvoice";
import EditInvoice from "./pages/invoicing/EditInvoice";
import InvoiceDetails from "./pages/invoicing/InvoiceDetails";
import InvoiceList from "./pages/invoicing/InvoiceList";
import DailyExpense from "./pages/office/DailyExpense";
import FixedExpense from "./pages/office/FixedExpense";
import Login from "./pages/user/Login";
import RouteProtected from "./utils/RouteProtection";
import { getStorageItem } from "./utils/helper";
export default function Router() {
  return (
    // <BrowserRouter>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<MainLayout />}>
        <Route
          path="home"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj" || "kjnmgh22578" || "astrfh126643"}

            >
              <Dashboard />
            </RouteProtected>
          }
        />
        <Route
          path="employeelist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <EmployeesList />
            </RouteProtected>
          }
        />
        <Route
          path="addemployee"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddEmployee />
            </RouteProtected>
          }
        />
        <Route
          path="employeeEdit/:id"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <EditEmployee />
            </RouteProtected>
          }
        />
        <Route
          path="employeeDetails/:id"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <EmployeeDetails />
            </RouteProtected>
          }
        />
        <Route
          path="dailyexpense"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <DailyExpense />
            </RouteProtected>
          }
        />
        <Route
          path="fixedexpense"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <FixedExpense />
            </RouteProtected>
          }
        />
        <Route
          path="businesslist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <BusinessList />
            </RouteProtected>
          }
        />
        <Route
          path="clientlist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <ClientList />
            </RouteProtected>
          }
        />
        <Route
          path="projectlist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <ProjectList />
            </RouteProtected>
          }
        />
        <Route
          path="invoicelist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <InvoiceList />
            </RouteProtected>
          }
        />
        <Route
          path="addinvoice"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddInvoice />
            </RouteProtected>
          }
        />
        <Route
          path="editinvoice/:id"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <EditInvoice />
            </RouteProtected>
          }
        />
        <Route
          path="invoicedetails/:id"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <InvoiceDetails />
            </RouteProtected>
          }
        />
        <Route
          path="demandletter"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <DemandLetters />
            </RouteProtected>
          }
        />
        <Route
          path="adddemandletter"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddDemandLetter />
            </RouteProtected>
          }
        />
        <Route
          path="employeecontract"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <EmployeeContracts />
            </RouteProtected>
          }
        />
        <Route
          path="addemployeecontract"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddEmployeeContract />
            </RouteProtected>
          }
        />
        <Route
          path="addLogisticsSupportQuotation"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddLogisticsSupportQuotation />
            </RouteProtected>
          }
        />
        <Route
          path="supportQuotation"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <SupportQuotation />
            </RouteProtected>
          }
        />
        <Route
          path="commitmentletter"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <CommitmentLetter />
            </RouteProtected>
          }
        />
        <Route
          path="salary"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <Salary />
            </RouteProtected>
          }
        />
        <Route
          path="addsalary"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <AddSalary />
            </RouteProtected>
          }
        />
        <Route
          path="salarydetails/:id"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <SalaryDetails />
            </RouteProtected>
          }
        />
        <Route
          path="expenseCategorylist"
          element={
            <RouteProtected
              isSignedIn={localStorage.getItem("auth_key") == "xxaa1112jnj"|| "kjnmgh22578" || "astrfh126643"}
            >
              <ExpenseCategory />
            </RouteProtected>
          }
        />
      </Route>
    </Routes>
    // </BrowserRouter>
  );
}
